import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const SazbaDph = {
	name: NAME,
	apiProvider,
	router,
};
